
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useToast } from "@/hooks/use-toast";
import { AlertCircle } from "lucide-react";
import { EmailData } from "./types";

interface EmailCardProps {
  email: EmailData;
  index: number;
}

const EmailCard = ({ email, index }: EmailCardProps) => {
  const { toast } = useToast();

  const handleVerifyEmail = (url: string) => {
    window.location.href = url;
  };

  const handleCopyToken = (token: string) => {
    navigator.clipboard.writeText(token);
    toast({
      title: "Copied!",
      description: "Token copied to clipboard",
    });
  };

  return (
    <Card key={index}>
      <CardHeader>
        <CardTitle>
          {email.type === 'confirm_signup' ? 'Email Verification' : 
           email.type === 'reset_password' ? 'Password Reset' : 
           'SMTP Test Email'}
        </CardTitle>
        <CardDescription>{email.subject || 'No subject'}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {email.url && (
            <div>
              <p className="text-sm font-medium">Action Link:</p>
              <div className="flex items-center gap-2 mt-1">
                <Button onClick={() => handleVerifyEmail(email.url as string)}>
                  {email.type === 'confirm_signup' ? 'Verify Email (Demo)' : 'Reset Password (Demo)'}
                </Button>
              </div>
              <p className="text-xs text-gray-500 mt-1">
                Note: This is a simulated link for testing the workflow
              </p>
            </div>
          )}
          
          {email.token && (
            <div>
              <p className="text-sm font-medium">Token:</p>
              <div className="flex items-center gap-2 mt-1">
                <code className="bg-gray-100 p-1 rounded">{email.token}</code>
                <Button size="sm" variant="outline" onClick={() => handleCopyToken(email.token as string)}>
                  Copy
                </Button>
              </div>
            </div>
          )}
          
          {email.content && (
            <div>
              <p className="text-sm font-medium">Content:</p>
              <div className="bg-gray-50 p-2 rounded mt-1 text-sm max-h-40 overflow-y-auto">
                {email.content}
              </div>
            </div>
          )}

          {email.smtp && (
            <div>
              <p className="text-sm font-medium">SMTP Server:</p>
              <div className="bg-gray-50 p-2 rounded mt-1 text-sm">
                {email.smtp.hostname}:{email.smtp.port} (User: {email.smtp.username})
              </div>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default EmailCard;
